const cadCardRowstyle = {paddingTop: '5px', borderTop: '1px solid rgb(242,242,242)', marginTop: '9px', marginLeft: '-12px', marginRight: '-12px', marginBottom: '-3px'}

export {cadCardRowstyle}
